var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "y0seakmmwa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.976471 0 0 0 0 0.352941 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#y0seakmmwa)",
    transform: "translate(-344.000000, -280.000000) translate(39.000000, 253.000000) translate(26.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D262C",
    d: "M15.38 7.643c.157 0 .3.068.412.184.104.123.157.276.142.438 0 .054-.419 5.35-.658 7.578-.15 1.368-1.032 2.199-2.354 2.222-1.017.022-2.012.03-2.99.03-1.04 0-2.056-.008-3.043-.03-1.278-.031-2.16-.876-2.303-2.222-.08-.727-.177-1.776-.272-2.863l-.044-.503c-.181-2.1-.344-4.178-.348-4.212-.008-.162.044-.315.15-.438.103-.116.253-.184.41-.184h10.899zm-3.83-5.262c.695 0 1.316.485 1.496 1.176l.128.574c.104.467.509.798.975.798h2.29c.307 0 .561.254.561.577v.298c0 .315-.254.577-.56.577H3.418c-.306 0-.56-.262-.56-.577v-.298c0-.323.254-.577.56-.577h2.29c.466 0 .871-.33.976-.797l.12-.536c.186-.73.8-1.215 1.502-1.215z",
    transform: "translate(279.000000, 0.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.df1d39a3.svg";
export { ForwardRef as ReactComponent };